module.exports = __webpack_public_path__ + "img/icon_machine_empty_blue.eab7d31d.svg";